import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Menu() {
	const location = useLocation()
	const [currentMenuItem, setCurrentMenuItem] = useState("")

	// Scroll to the top on route change
	useEffect(() => {
		setCurrentMenuItem(location.pathname)
		window.scrollTo(0, 0) // This will scroll the page to the top whenever the route changes
	}, [location.pathname])

	const checkCurrentMenuItem = (path) => currentMenuItem === path ? "current-menu-item" : ""
	const checkParentActive = (paths) => paths.some(path => currentMenuItem.startsWith(path)) ? "current-menu-item" : ""

	return (
		<>
			<ul className="menu">
				<li className={`item ${location.pathname === "/" ? "current-menu-item" : ""}`}><Link to="/">HOME</Link></li>
				<li className={`item ${location.pathname.startsWith("/arenas") ? "current-menu-item" : ""}`}><Link to="/arenas-academies">OUR ARENAS &amp; ACADEMIES</Link></li>
				<li className="item"><Link to="#">EXPERIENCES</Link></li>
				<li className="item"><Link to="#">MEMBERSHIP</Link></li>
				<li className="item"><a href="https://book.proplay.zone/" target="_blank" rel="noreferrer">PARTNER WITH US</a></li>
				<li className={`item ${location.pathname === "/about" ? "current-menu-item" : ""}`}><Link to="/about">ABOUT US</Link></li>
			</ul>{/* /.menu */}
		</>
	)
}
